export const getRefundStatusType = refundData => {
  if (!refundData) return null

  const refundType = refundData?.cancellationRequest?.refundType
  const cancellationStatus = refundData?.cancellationRequest?.status
  const refundStatus = refundData?.cancellationRequest?.refundStatus ?? refundData?.refundSummary?.refundStatus

  if (refundType !== 'pix' || refundStatus == null) {
    return null
  }

  if (refundStatus === 'canceled') {
    return 'pixError'
  }

  if (!['done', 'approved'].includes(cancellationStatus)) {
    return null
  }

  if (['pending', 'processing', 'approved'].includes(refundStatus)) return 'inProgress'
  if (refundStatus === 'done') return 'done'

  return null
}
